<template>
<!-- this major component deal with  craeting of mail adding of the recipient and subject-->
    <div>
       <div class="row justify-content-center">
           <div class="col-md-4">
            <div class="card">
                <div class="card-body">
                    <div class="card-text">
                        <div class="">
                        <span class="fa fa-check-circle-o"></span> <br>
                        <h6>To</h6> 
                        </div>
                        <p class="p">
                             Who are you sending this campaign to?
                        </p>
                        <div class="clearfix mt-2">
                            <div class="float-right">
                                <button class="btn btn-info" @click="recipient">Add Recipient</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
           </div>
           <!--  -->
            <div class="col-md-4">
            <div class="card">
                <div class="card-body">
                    <div class="card-text">
                        <div class="">
                        <span class="fa fa-check-circle-o"></span> <br>
                        <h6>From</h6> 
                        </div>
                        <p class="p">
                             Who is sending this campaign?
                        </p>
                        <div class="clearfix mt-2">
                            <div class="float-right">
                                <button class="btn btn-info" @click="addFrom">Add From</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
           </div>
           <!--  -->
           <div class="col-md-4">
            <div class="card">
                <div class="card-body">
                    <div class="card-text">
                        <div class="">
                        <span class="fa fa-check-circle-o"></span> <br>
                        <h6>Subject</h6> 
                        </div>
                        <p class="p">
                            What's the subject line for this campaign?
                        </p>
                        <div class="clearfix mt-2">
                            <div class="float-right">
                                <button class="btn btn-info">Add Subject</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
           </div>
           <!--  -->
       </div>
    </div>
</template>
<script>
export default {
    data(){
        return{

        }
    },
    methods:{
        recipient(){
            this.$router.replace({name:'methods'})
        },
        addFrom(){
            this.$router.replace ({name:'addfrom'})
        }
    }
}
</script>

<style lang="css" scoped>
    .fa{
        font-size: 25px ;
        color: grey;
        /* color: #0185a0; */
    }
    .p{
        font-style: italic;
        font-size: 18px;
    }
</style>